import { padZero } from './number';

export function stringToColor(str: string) {
  let hash = 0;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < str.length; i++) {
    // eslint-disable-next-line no-bitwise
    hash = str.toLowerCase().charCodeAt(i) + ((hash << 5) - hash);
  }
  let colour = '';
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < 3; i++) {
    // eslint-disable-next-line no-bitwise
    const value = (hash >> (i * 8)) & 0xff;
    colour += `#00${value.toString(16)}`.substr(-2);
  }
  return `#${colour}`;
}

export function invertColor(hex: string, bw: boolean) {
  let newHex = hex;
  if (newHex.indexOf('#') === 0) {
    newHex = newHex.slice(1);
  }
  if (newHex.length === 3) {
    newHex =
      newHex[0] + newHex[0] + newHex[1] + newHex[1] + newHex[2] + newHex[2];
  }
  if (newHex.length !== 6) {
    throw new Error('Invalid HEX color.');
  }
  let r: number | string = parseInt(newHex.slice(0, 2), 16);
  let g: number | string = parseInt(newHex.slice(2, 4), 16);
  let b: number | string = parseInt(newHex.slice(4, 6), 16);
  if (bw) {
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '000000' : 'FFFFFF';
  }
  r = (255 - r).toString(16);
  g = (255 - g).toString(16);
  b = (255 - b).toString(16);
  return `${padZero(r)}${padZero(g)}${padZero(b)}`;
}
